export function fetchEventsMessage(type) {
  return {
    method: 'repository:fetchEvents',
    params: {
      type,
    },
  }
}

export const sendEventMessage = message => {
  return {
    method: 'repository:sendEvent',
    params: {...message},
  }
}


export const statsMessage = message => {
  return {
    method: 'repository:sendStats',
    params: {...message},
  }
}
